var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "nk-app-root" },
    [
      _c("key-search", { ref: "keySearch" }),
      _vm._v(" "),
      _c("ai-assistant-widget"),
      _vm._v(" "),
      _c("pwa-install-fab"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "nk-main" },
        [
          _c("app-sidebar", { attrs: { "is-dark-mode": _vm.isDarkMode } }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "nk-wrap" },
            [
              _c(
                "div",
                {
                  staticClass:
                    "nk-header is-light nk-header-fixed sip-admin-header",
                },
                [
                  _c("div", { staticClass: "container-xl wide-xl" }, [
                    _c(
                      "div",
                      { staticClass: "nk-header-wrap sip-admin-header__wrap" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "nk-header-brand d-flex align-items-center",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "nk-menu-trigger sip-header-hamburger d-xl-none",
                              },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "nk-nav-toggle sip-icon-btn sip-header-btn--menu",
                                    attrs: {
                                      id: "OpenMenuSideBar",
                                      "data-target": "sidebarMenu",
                                      "aria-label": "Open menu",
                                    },
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "menu", size: 18 },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "sip-global-search-pill d-none d-md-flex",
                                attrs: { role: "search", tabindex: "0" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.openTypeAnywhereSearch.apply(
                                      null,
                                      arguments
                                    )
                                  },
                                  keydown: [
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      )
                                        return null
                                      $event.preventDefault()
                                      return _vm.openTypeAnywhereSearch.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                    function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "space",
                                          32,
                                          $event.key,
                                          [" ", "Spacebar"]
                                        )
                                      )
                                        return null
                                      $event.preventDefault()
                                      return _vm.openTypeAnywhereSearch.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  ],
                                },
                              },
                              [
                                _c("admin-icon", {
                                  staticClass: "sip-search-icon",
                                  attrs: { name: "search", size: 16 },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  { staticClass: "sip-search-placeholder" },
                                  [
                                    _vm._v(
                                      "Search students, staff, classes, fees, documents..."
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("kbd", { staticClass: "sip-kbd" }, [
                                  _vm._v("⌘K"),
                                ]),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "nk-header-tools" }, [
                          _c("ul", { staticClass: "nk-quick-nav" }, [
                            _c("li", { staticClass: "nav-item d-md-none" }, [
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "sip-icon-btn sip-header-btn--search",
                                  attrs: {
                                    type: "button",
                                    title: _vm.trans(
                                      "general.any_search_title"
                                    ),
                                    "aria-label": _vm.trans(
                                      "general.any_search_title"
                                    ),
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.openTypeAnywhereSearch.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("admin-icon", {
                                    attrs: { name: "search", size: 18 },
                                  }),
                                ],
                                1
                              ),
                            ]),
                            _vm._v(" "),
                            _vm.getAcademicSessions.length &&
                            _vm.hasPermission("change-academic-session")
                              ? _c("li", { staticClass: "nav-item dropdown" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "sip-session-pill dropdown-toggle",
                                      attrs: {
                                        href: "#",
                                        "data-toggle": "dropdown",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false",
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "sip-status-dot",
                                        attrs: { "aria-hidden": "true" },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "sip-session-label" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.sessionDisplayTitle)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("admin-icon", {
                                        staticClass: "sip-session-chevron",
                                        attrs: {
                                          name: "chevron-down",
                                          size: 12,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "dropdown-menu dropdown-menu-md sip-session-dropdown",
                                        _vm.getConfig("direction") != "rtl"
                                          ? "dropdown-menu-right"
                                          : "",
                                      ],
                                    },
                                    [
                                      _vm._m(0),
                                      _vm._v(" "),
                                      _c(
                                        "ul",
                                        {
                                          staticClass:
                                            "dropdown-user sip-session-list",
                                        },
                                        [
                                          _vm._l(
                                            _vm.getAcademicSessions,
                                            function (academic_session) {
                                              return _c(
                                                "li",
                                                {
                                                  key: academic_session.id,
                                                  class: {
                                                    "is-active":
                                                      _vm.getDefaultAcademicSession &&
                                                      academic_session.id ==
                                                        _vm
                                                          .getDefaultAcademicSession
                                                          .id,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.setDefaultAcademicSession(
                                                        academic_session
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "sip-session-item-name",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          academic_session.name
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.getDefaultAcademicSession &&
                                                  academic_session.id ==
                                                    _vm
                                                      .getDefaultAcademicSession
                                                      .id
                                                    ? _c("admin-icon", {
                                                        staticClass:
                                                          "sip-check-icon text-primary",
                                                        attrs: {
                                                          name: "check",
                                                          size: 14,
                                                        },
                                                      })
                                                    : _vm._e(),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                          _vm._v(" "),
                                          _vm.hasPermission(
                                            "create-academic-session"
                                          )
                                            ? _c(
                                                "li",
                                                {
                                                  staticClass:
                                                    "sip-add-session-btn",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.$router.push(
                                                        "/academic/session"
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("admin-icon", {
                                                    staticClass: "me-1",
                                                    attrs: {
                                                      name: "plus",
                                                      size: 14,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          "academic.add_new_session"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        2
                                      ),
                                    ]
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.getConfig("todo") &&
                            _vm.hasPermission("access-todo")
                              ? _c(
                                  "li",
                                  {
                                    staticClass: "nav-item d-none d-md-inline",
                                  },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        staticClass:
                                          "sip-icon-btn sip-header-btn--todo",
                                        attrs: {
                                          to: "/utility/todo",
                                          title: _vm.trans("utility.todo"),
                                          "aria-label":
                                            _vm.trans("utility.todo"),
                                        },
                                      },
                                      [
                                        _c("admin-icon", {
                                          attrs: {
                                            name: "check-circle",
                                            size: 18,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "nav-item sip-theme-picker-slot" },
                              [_c("theme-picker", { ref: "themePicker" })],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "nav-item sip-inbox-slot" },
                              [
                                _c("header-notifications", {
                                  ref: "headerInbox",
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "nav-item d-none d-md-inline" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "sip-icon-btn sip-header-btn--theme",
                                    attrs: {
                                      type: "button",
                                      title: _vm.isDarkMode
                                        ? "Switch to Light Mode"
                                        : "Switch to Dark Mode",
                                      "aria-label": _vm.isDarkMode
                                        ? "Switch to Light Mode"
                                        : "Switch to Dark Mode",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.toggleDarkMode.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _vm.isDarkMode
                                      ? _c("admin-icon", {
                                          attrs: { name: "sun", size: 18 },
                                        })
                                      : _c("admin-icon", {
                                          attrs: { name: "moon", size: 18 },
                                        }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "nav-item d-none d-md-inline" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "sip-icon-btn sip-header-btn--refresh",
                                    class: {
                                      "is-refreshing": _vm.isRefreshing,
                                    },
                                    attrs: {
                                      type: "button",
                                      title: _vm.trans("general.refresh"),
                                      "aria-label":
                                        _vm.trans("general.refresh"),
                                      disabled: _vm.isRefreshing,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.softRefresh.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("admin-icon", {
                                      attrs: { name: "refresh", size: 18 },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "li",
                              { staticClass: "dropdown user-dropdown" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "sip-profile-btn dropdown-toggle",
                                    attrs: {
                                      href: "#",
                                      "data-toggle": "dropdown",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "false",
                                    },
                                  },
                                  [
                                    _c("span", { staticClass: "sip-avatar" }, [
                                      _vm._v(_vm._s(_vm.userInitials)),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "sip-profile-meta-wrap d-none d-md-flex flex-column text-start",
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "sip-profile-name" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.getAuthUser("name"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "sip-profile-role-pill",
                                          },
                                          [_vm._v(_vm._s(_vm.userRoleTitle))]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("admin-icon", {
                                      staticClass: "sip-profile-chevron",
                                      attrs: { name: "chevron-down", size: 13 },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "dropdown-menu dropdown-menu-md user-dropdown-menu sip-user-menu",
                                      _vm.getConfig("direction") != "rtl"
                                        ? "dropdown-menu-right"
                                        : "",
                                    ],
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "sip-user-menu-header" },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "sip-user-menu-avatar",
                                          },
                                          [_vm._v(_vm._s(_vm.userInitials))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "sip-user-menu-info" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "sip-user-menu-name",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getAuthUser("name")
                                                  )
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.getAuthUser("email")
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "sip-user-menu-email",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getAuthUser("email")
                                                      )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "sip-user-menu-badge",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.userRoleTitle)
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "dropdown-inner" },
                                      [
                                        _c(
                                          "ul",
                                          {
                                            staticClass:
                                              "link-list link-list-opt no-bdr",
                                          },
                                          [
                                            _c(
                                              "li",
                                              { staticClass: "d-md-none" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.toggleDarkMode.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm.isDarkMode
                                                      ? _c("admin-icon", {
                                                          attrs: {
                                                            name: "sun",
                                                            size: 16,
                                                          },
                                                        })
                                                      : _c("admin-icon", {
                                                          attrs: {
                                                            name: "moon",
                                                            size: 16,
                                                          },
                                                        }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.isDarkMode
                                                            ? "Light mode"
                                                            : "Dark mode"
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              { staticClass: "d-md-none" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.openThemePicker.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("admin-icon", {
                                                      attrs: {
                                                        name: "palette",
                                                        size: 16,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v("Colour & fonts"),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm.getConfig("todo") &&
                                            _vm.hasPermission("access-todo")
                                              ? _c(
                                                  "li",
                                                  { staticClass: "d-md-none" },
                                                  [
                                                    _c(
                                                      "router-link",
                                                      {
                                                        attrs: {
                                                          to: "/utility/todo",
                                                        },
                                                      },
                                                      [
                                                        _c("admin-icon", {
                                                          attrs: {
                                                            name: "check-circle",
                                                            size: 16,
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.trans(
                                                                "utility.todo"
                                                              )
                                                            )
                                                          ),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              { staticClass: "d-md-none" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    class: {
                                                      "is-refreshing":
                                                        _vm.isRefreshing,
                                                    },
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.softRefresh.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("admin-icon", {
                                                      attrs: {
                                                        name: "refresh",
                                                        size: 16,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.trans(
                                                            "general.refresh"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: { href: "#" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.preventDefault()
                                                      return _vm.openInbox.apply(
                                                        null,
                                                        arguments
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("admin-icon", {
                                                    attrs: {
                                                      name: "bell",
                                                      size: 16,
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          "communication.notifications"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            !_vm.isPwaStandalone
                                              ? _c(
                                                  "li",
                                                  {
                                                    attrs: {
                                                      "data-sip-app-download":
                                                        "1",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "a",
                                                      {
                                                        attrs: { href: "#" },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.installPwaApp.apply(
                                                              null,
                                                              arguments
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("admin-icon", {
                                                          attrs: {
                                                            name: "download",
                                                            size: 16,
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("span", [
                                                          _vm._v(
                                                            "App Download"
                                                          ),
                                                        ]),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _vm.hasRole("admin")
                                              ? _c("li", [
                                                  _c(
                                                    "a",
                                                    {
                                                      attrs: {
                                                        href: "/subscription",
                                                      },
                                                    },
                                                    [
                                                      _c("admin-icon", {
                                                        attrs: {
                                                          name: "card",
                                                          size: 16,
                                                        },
                                                      }),
                                                      _c("span", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.trans(
                                                              "subscription.subscription"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                                ])
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("li", [
                                              _c(
                                                "a",
                                                {
                                                  attrs: {
                                                    href: "/change/password",
                                                  },
                                                },
                                                [
                                                  _c("admin-icon", {
                                                    attrs: {
                                                      name: "lock",
                                                      size: 16,
                                                    },
                                                  }),
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.trans(
                                                          "user.change_password"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "li",
                                              {
                                                staticClass:
                                                  "border-top pt-1 mt-1",
                                              },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass: "text-danger",
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.preventDefault()
                                                        return _vm.logout.apply(
                                                          null,
                                                          arguments
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("admin-icon", {
                                                      attrs: {
                                                        name: "logout",
                                                        size: 16,
                                                      },
                                                    }),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.trans(
                                                            "auth.logout"
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "nk-content nk-content-fluid" }, [
                _c("div", { staticClass: "container-xl wide-xl" }, [
                  _c(
                    "div",
                    {
                      staticClass: "nk-content-body sip-content-outlet",
                      attrs: {
                        "aria-busy": _vm.showRouteSkeleton ? "true" : "false",
                      },
                    },
                    [
                      _c(
                        "transition",
                        { attrs: { name: "sip-page" } },
                        [_c("router-view", { key: _vm.pageViewKey })],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "nk-footer" }, [
                _c("div", { staticClass: "container-xl wide-xl" }, [
                  _c(
                    "div",
                    { staticClass: "nk-footer-wrap" },
                    [_c("app-footer")],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("mobile-bottom-nav"),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "sip-dropdown-header" }, [
      _c("span", { staticClass: "sip-dropdown-header__title" }, [
        _vm._v("Academic Sessions"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }